<h3>Products <span class="highlight">(Click on a product to edit)</span></h3>
<a routerLink="/addproduct" routerLinkActive="active" class="btn btn-default">Add Product</a>
<hr>
<div class="container divtable">
    <div class="divtablebody">
        <div class="divrow">

            <div class="coltitle   appcol codecol-emp " >Code</div>
            
            <div class="coltitle  appcol fnamecol-emp ">Description</div>
            
            <div class="coltitle appcol lnamecol-emp ">Description 2</div>
            
            <div class="coltitle   appcol uploadedcol-emp">UOM</div>

            <div class="coltitle   appcol btncol-emp">&nbsp;</div>

        </div>
        
         @for (product of products; track product.productcode) {
        <div class="divrow" (click)="onEdit(product)">

            <div class="appcol  codecol-emp appcell">{{product.productcode}}</div>
                    
            <div class="appcol  fnamecol-emp appcell">{{product.description}}</div>
                    
            <div class="appcol  lnamecol-emp appcell">{{product.description2}}</div>
                    
            <div class="appcol  uploadedcol-emp appcell">{{product.uom}}</div>

            <div class="appcol  btncol-emp appcell">
                      <button class="delete btn-xs btn-danger" (click)="deleteProduct(product); $event.stopPropagation()">Delete</button>    
            </div>
        </div>
        }
      </div>
    </div>

